import { render, staticRenderFns } from "./additional_family_members.vue?vue&type=template&id=0d03f8d2&"
import script from "./additional_family_members.vue?vue&type=script&lang=js&"
export * from "./additional_family_members.vue?vue&type=script&lang=js&"
import style0 from "./additional_family_members.vue?vue&type=style&index=0&id=0d03f8d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports